export default "__VITE_ASSET__DId2yPn1__"